import React from 'react';
import { FaAmazon, FaShopify, FaMeta, FaYoutube, FaTiktok, FaInstagram } from 'react-icons/fa6';
import useLandingAssets from '../hooks/useLandingAssets';
import { flattenBrands } from '../lib/landingAssets';

const PLATFORMS = [
  { name: 'amazon', icon: FaAmazon },
  { name: 'shopify', icon: FaShopify },
  { name: 'Meta', icon: FaMeta },
  { name: 'YouTube', icon: FaYoutube },
  { name: 'TikTok', icon: FaTiktok },
  { name: 'Instagram', icon: FaInstagram },
];

const TrustedBy = () => {
  const sections = useLandingAssets();
  const brandLogos = flattenBrands(sections?.brands);
  const hasApiLogos = brandLogos.length > 0;
  const loop = hasApiLogos ? [...brandLogos, ...brandLogos, ...brandLogos] : [...PLATFORMS, ...PLATFORMS, ...PLATFORMS];

  return (
    <section className="bg-[#0b0814] text-white py-12 overflow-hidden" data-testid="trusted-by-section">
      <div className="mx-auto max-w-7xl px-6 mb-8">
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight" data-testid="trusted-by-title">
          {hasApiLogos ? 'Trusted by creators and businesses worldwide.' : 'Create for every platform you sell and post on.'}
        </h2>
      </div>
      <div className="relative">
        <div className="flex items-center gap-8 w-max animate-marquee">
          {loop.map((item, idx) =>
            hasApiLogos ? (
              <span key={`${item.url}-${idx}`} className="shrink-0 h-16 px-5 rounded-xl bg-white flex items-center"><img src={item.url} alt={item.caption || 'brand logo'} loading="lazy" className="h-12 w-auto max-w-[140px] object-contain" data-testid="brand-logo" /></span>
            ) : (
              <span key={`${item.name}-${idx}`} className="flex items-center gap-2 text-xl font-bold text-white/80 select-none" data-testid="platform-logo">
                <item.icon size={24} /> {item.name}
              </span>
            )
          )}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0b0814] to-transparent" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0b0814] to-transparent" />
      </div>
    </section>
  );
};

export default TrustedBy;
